export const css = {
    root: '_2_KbdgGa',
    tabTitle: 'W68fWj5L',
    title: '_16rgT5bN',
    titleClosed: '_2HCBWxgH',
    titleOpen: '_3vViwQ1s',
    bookIcon: '_4pLpoQ5k',
    lockIcon: '_3b-pTAEB',
    ' _key': 'afcpe-theme/afcpe/explore-view/content-order'
};
export default css;
